/* eslint-disable jsx-a11y/media-has-caption */
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function VideoStream({ videoTrack, nameLabel }) {
  const classes = useStyles();
  const videoRef = useRef();
  const { t } = useTranslation('labels');

  useEffect(() => {
    if (videoTrack && videoTrack.attach) {
      videoTrack.attach(videoRef.current);
      return () => {
        videoTrack.removeAllListeners();
        videoTrack.detach();
      };
    }
  }, [videoTrack]);

  return (
    <div className={classes.videoRoomParticipant}>
      <video className={classes.sharingVideoElement} ref={videoRef} autoPlay />
      <Typography className={cn(classes.participantName, classes.smallParticipantName)} variant="body2" component="span" noWrap>
        {`${nameLabel} ${t('is_sharing_screen')}`}
      </Typography>
    </div>
  );
}

VideoStream.propTypes = {
  videoTrack: PropTypes.objectOf(PropTypes.any),
  nameLabel: PropTypes.string,
};

VideoStream.defaultProps = {
  videoTrack: null,
  nameLabel: '',
};

export default VideoStream;
